// extracted by mini-css-extract-plugin
module.exports = {"EventPropagationStopper":"EventPropagationStopper_EventPropagationStopper__1sFGL"};